export const KPI_WEEKLY_REVENUE = ({ processedDashboardData, targetWeeklyRevenue, theme }) => {
    return (
        <div style={{
            background: theme === 'light' ? '#fff' : '#333',
            padding: '20px',
            borderRadius: '12px',
            boxShadow: '0 6px 12px rgba(0,0,0,0.08)',
            border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
            position: 'relative',
            overflow: 'hidden'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= targetWeeklyRevenue ? '#28a745' : 
                            (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= 0 ? '#ffc107' : '#dc3545'
            }}></div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                <div>
                    <h4 style={{ color: '#6c757d', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', margin: '0 0 6px 0', letterSpacing: '0.5px' }}>
                        WEEKLY REVENUE TREND
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={{ 
                            fontSize: '36px', 
                            fontWeight: 'bold', 
                            color: (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= targetWeeklyRevenue ? '#28a745' : 
                                    (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= 0 ? '#ffc107' : '#dc3545',
                            lineHeight: '1'
                        }}>
                            {(processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) > 0 ? '+' : ''}{processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0}%
                        </span>
                        <span style={{
                            fontSize: '14px',
                            color: (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= targetWeeklyRevenue ? '#28a745' : 
                                    (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= 0 ? '#ffc107' : '#dc3545',
                            fontWeight: '600',
                            textTransform: 'uppercase'
                        }}>
                            {(processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= targetWeeklyRevenue ? 'STRONG' : 
                                (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= 0 ? 'STABLE' : 'DECLINE'}
                        </span>
                    </div>
                </div>
                <div style={{
                    background: (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= targetWeeklyRevenue ? 'rgba(40, 167, 69, 0.1)' : 
                                (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= 0 ? 'rgba(255, 193, 7, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                    padding: '8px',
                    borderRadius: '8px',
                    fontSize: '18px'
                }}>
                    📈
                </div>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: theme === 'light' ? '#6c757d' : '#adb5bd',
                marginBottom: '12px'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>This week:</span><span>£{processedDashboardData?.weeklyRevenueKpis?.thisWeekRevenue?.toFixed(2) || '0.00'}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Last week:</span><span>£{processedDashboardData?.weeklyRevenueKpis?.lastWeekRevenue?.toFixed(2) || '0.00'}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Change:</span><span>{(processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) > 0 ? '+' : ''}£{((processedDashboardData?.weeklyRevenueKpis?.thisWeekRevenue || 0) - (processedDashboardData?.weeklyRevenueKpis?.lastWeekRevenue || 0)).toFixed(2)}</span>
                </div>
            </div>
            
            <div style={{ 
                fontSize: '12px', 
                color: (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= targetWeeklyRevenue ? '#28a745' : 
                        (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= 0 ? '#ffc107' : '#dc3545',
                fontWeight: '600',
                textTransform: 'uppercase'
            }}>
                Target: ≥+{targetWeeklyRevenue}% • {(processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= targetWeeklyRevenue ? 'GROWING' : (processedDashboardData?.weeklyRevenueKpis?.percentageChange || 0) >= 0 ? 'STABLE' : 'DECLINING'} • Week on Week
            </div>
        </div>
    )
}